import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { ThemeProvider, Themed } from "theme-ui";
import theme from "./theme";
import * as serviceWorker from "./serviceWorker";
import apolloClient from "api/apollo-client";
import { ApolloProvider } from "@apollo/client";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import ErrorBoundary from "components/ErrorBoundary";

Sentry.init({
  environment: "staging",
  dsn: "https://996279ea5ec9496683ef6efb7e180948@sentry.twiga.tech//33",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={theme}>
        <Themed.div>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </Themed.div>
      </ThemeProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
